import { render } from "./Formulario.vue?vue&type=template&id=53e773b8&scoped=true"
import script from "./Formulario.vue?vue&type=script&lang=js"
export * from "./Formulario.vue?vue&type=script&lang=js"

import "./formulario.scss?vue&type=style&index=0&id=53e773b8&lang=scss&scoped=true&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e773b8"]])

export default __exports__